// import link from './image/link.png';
import * as EditorTypeAll from '../tinymce.d';
import { useLinkManager } from '../LinkManager';
import { Link2 } from 'lucide-react';

interface Props {
  editorInstance: EditorTypeAll.Editor;
}

const Link = ({ editorInstance }: Props) => {
  const { openLinkDialog } = useLinkManager();

  const linkAction = () => {
    document.body.click();
    openLinkDialog(editorInstance);
  };

  return (
    <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]" onClick={linkAction}>
      {/* <img width="18px" height="18px" src={link} /> */}
      <Link2 strokeWidth={1.5} size={18} />
    </div>
  );
};

export default Link;
